import UsuariosPreparacaoTypes from './types'

export const searchSuccess = (data) => ({
    type: UsuariosPreparacaoTypes.SEARCH_SUCCESS,
    payload: data
});

export const searchRequest = () => ({
    type: UsuariosPreparacaoTypes.SEARCH_REQUEST
});

export const searchFailure = () => ({
    type: UsuariosPreparacaoTypes.SEARCH_FAILURE
});

export const recoverPreparations = (filter) => {
    return { type: UsuariosPreparacaoTypes.RECOVER_PREPARATIONS, filter };
};

export const createPreparation = (body) => {
    return {
        type: UsuariosPreparacaoTypes.CREATE_PREPARATION, body
    };
};

export const createSuccess = (data) => {
    return {
        type: UsuariosPreparacaoTypes.CREATE_SUCCESS, data
    }
}

export const deletePreparation = (id) => {
    return { type: UsuariosPreparacaoTypes.DELETE_PREPARATION, id };
};

export const deleteSuccess = () => {
    return { type: UsuariosPreparacaoTypes.DELETE_SUCCESS };
};
